import Vue from "vue";
import vuex from "vuex";
import axios from "axios";
import mobizoneStore from "./modules/mobizone-store";
import mobiscopeStore from "./modules/mobiscope-store";
import games4allStore from "./modules/games4all-store";
import mobiflixStore from "./modules/mobiflix-store";
import miximoStore from "./modules/miximo-store";
import gameknightStore from "./modules/gameknight-store";
import gameonzStore from "./modules/gameonz-store";
import funplusStore from "./modules/funplus-store";
import gameboxStore from "./modules/gamebox-store";
import prizeoStore from "./modules/prizeo-store";
import fun2winStore from "./modules/fun2win-store";
import cutemobiStore from "./modules/cutemobi-store";
import cutehubStore from "./modules/cutehub-store";
import apps4allStore from "./modules/apps4all-store";
import playmixStore from "./modules/playmix-store";

Vue.use(vuex, axios);

export default new vuex.Store({
  modules: {
    // namespaced: '',
    mobizoneStore,
    mobiscopeStore,
    games4allStore,
    mobiflixStore,
    miximoStore,
    gameknightStore,
    gameonzStore,
    funplusStore,
    gameboxStore,
    prizeoStore,
    fun2winStore,
    cutemobiStore,
    cutehubStore,
    apps4allStore,
    playmixStore
  },
  state: {},
  actions: {},
  mutations: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js